import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	plan: {
		id: 'navigation-apps-sidebar-plan.menu.plan',
		defaultMessage: 'Plan',
		description: 'Subtitle under the plan name',
	},
	planning: {
		id: 'navigation-apps-sidebar-plan.menu.planning',
		defaultMessage: 'Planning',
		description: 'Title for planning section',
	},
	summary: {
		id: 'navigation-apps-sidebar-plan.menu.summary',
		defaultMessage: 'Summary',
		description: 'Navigation item which is the title of summary page sidebar',
	},
	calendar: {
		id: 'navigation-apps-sidebar-plan.menu.calendar',
		defaultMessage: 'Calendar',
		description: 'Navigation item which is the title of calendar page sidebar',
	},
	timeline: {
		id: 'navigation-apps-sidebar-plan.menu.timeline',
		defaultMessage: 'Timeline',
		description: 'Navigation item which is the title of roadmap page sidebar',
	},
	increments: {
		id: 'navigation-apps-sidebar-plan.menu.increments',
		defaultMessage: 'Program',
		description: 'Navigation item which is the title of the programs page sidebar',
	},
	teams: {
		id: 'navigation-apps-sidebar-plan.menu.teams',
		defaultMessage: 'Teams',
		description: 'Navigation item which is the title of teams page sidebar',
	},
	releases: {
		id: 'navigation-apps-sidebar-plan.menu.releases',
		defaultMessage: 'Releases',
		description: 'Navigation item which is the title of releases page sidebar',
	},
	dependencies: {
		id: 'navigation-apps-sidebar-plan.menu.dependencies',
		defaultMessage: 'Dependencies',
		description: 'Navigation item which is the title of dependencies page sidebar',
	},
	planInfo: {
		id: 'navigation-apps-sidebar-plan.menu.plan-info',
		defaultMessage: 'Plan info',
		description: 'Navigation item which is the title of plan info page sidebar',
	},
	features: {
		id: 'navigation-apps-sidebar-plan.menu.features',
		defaultMessage: 'Features',
		description: 'Navigation item which is the title of features page sidebar',
	},
	backToPlan: {
		id: 'navigation-apps-sidebar-plan.menu.back-to-plan',
		defaultMessage: 'Back to plan',
		description: 'Text for link back to plan page',
	},
	planSettings: {
		id: 'navigation-apps-sidebar-plan.menu.plan-settings',
		defaultMessage: 'Plan settings',
		description: 'Navigation item which is the title of plan settings page sidebar',
	},
	general: {
		id: 'navigation-apps-sidebar-plan.menu.general',
		defaultMessage: 'General',
		description: 'Title for general settings section',
	},
	scheduling: {
		id: 'navigation-apps-sidebar-plan.menu.scheduling',
		defaultMessage: 'Scheduling',
		description: 'Navigation item which is the title of scheduling page sidebar',
	},
	savedViews: {
		id: 'navigation-apps-sidebar-plan.menu.saved-views',
		defaultMessage: 'Saved views',
		description: 'Navigation item which is the title of saved views page sidebar',
	},
	programBoards: {
		id: 'navigation-apps-sidebar-plan.menu.program-boards',
		defaultMessage: 'Program boards',
		description: 'Navigation item which is the title of program boards page sidebar',
	},
	sourceData: {
		id: 'navigation-apps-sidebar-plan.menu.source-data',
		defaultMessage: 'Source data',
		description: 'Title for source data settings section',
	},
	issueSources: {
		id: 'navigation-apps-sidebar-plan.menu.issue-sources',
		defaultMessage: 'Issue sources',
		description: 'Navigation item which is the title of issue sources page sidebar',
	},
	exclusionRules: {
		id: 'navigation-apps-sidebar-plan.menu.exclusion-rules',
		defaultMessage: 'Exclusion rules',
		description: 'Navigation item which is the title of exclusion rules page sidebar',
	},
	removedIssues: {
		id: 'navigation-apps-sidebar-plan.menu.removed-issues',
		defaultMessage: 'Removed issues',
		description: 'Navigation item which is the title of removed issues page sidebar',
	},
	findYourIssue: {
		id: 'navigation-apps-sidebar-plan.menu.find-your-issue',
		defaultMessage: 'Find your issue',
		description: 'Navigation item which is the title of find your issue page sidebar',
	},
	customFields: {
		id: 'navigation-apps-sidebar-plan.menu.custom-fields',
		defaultMessage: 'Custom fields',
		description: 'Navigation item which is the title of custom fields page sidebar',
	},
	accessControl: {
		id: 'navigation-apps-sidebar-plan.menu.access-control',
		defaultMessage: 'Access control',
		description: 'Title for access control settings section',
	},
	permissions: {
		id: 'navigation-apps-sidebar-plan.menu.permissions',
		defaultMessage: 'Permissions',
		description: 'Navigation item which is the title of permissions page sidebar',
	},
	advanced: {
		id: 'navigation-apps-sidebar-plan.menu.advanced',
		defaultMessage: 'Advanced',
		description: 'Title for advanced settings section',
	},
	scenarios: {
		id: 'navigation-apps-sidebar-plan.menu.scenarios',
		defaultMessage: 'Scenarios',
		description: 'Navigation item which is the title of scenarios page sidebar',
	},
	autoScheduler: {
		id: 'navigation-apps-sidebar-plan.menu.auto-scheduler',
		defaultMessage: 'Auto-scheduler',
		description: 'Navigation item which is the title of Auto-scheduler page sidebar',
	},
	footerWhatArePlans: {
		id: 'navigation-apps-sidebar-plan.menu.footer-what-are-plans',
		defaultMessage: 'What are plans?',
		description: 'Link to learn more article.',
	},
	earlyAccess: {
		id: 'navigation-apps-sidebar-plan.menu.early-access-no-translate',
		defaultMessage: 'Early access',
		description: 'Lozenge to mark the increment planning early access phase',
	},
	issueSourcesIssueTermRefresh: {
		id: 'navigation-apps-sidebar-plan.menu.issue-sources-issue-term-refresh',
		defaultMessage: 'Work item sources',
		description: 'Navigation item which is the title of issue sources page sidebar',
	},
	removedIssuesIssueTermRefresh: {
		id: 'navigation-apps-sidebar-plan.menu.removed-issues-issue-term-refresh',
		defaultMessage: 'Removed work items',
		description: 'Navigation item which is the title of removed issues page sidebar',
	},
	findYourIssueIssueTermRefresh: {
		id: 'navigation-apps-sidebar-plan.menu.find-your-issue-issue-term-refresh',
		defaultMessage: 'Find your work item',
		description: 'Navigation item which is the title of find your issue page sidebar',
	},
	newLozenge: {
		id: 'navigation-apps-sidebar-plan.menu.new-lozenge',
		defaultMessage: 'New',
		description: 'The text is shown on a lozenge on side navigation, to indicate this page is new.',
	},
});
